<template>
  <div id="app">
    <router-view/>
    <div v-show="openPayDiv" class="open-pay-div">
      <el-dialog :visible.sync="openPayModal" width="300px" :close-on-click-modal="false" :before-close="beforeClose"
                 :close-on-press-escape="false" style="right: 0;left: auto;" :modal="false">
        <payModel ref="childPay"></payModel>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import payModel from '@/components/payModel'

export default {
  data() {
    return {
      openPayModal: true,
      openPayDiv: false
    }
  },
  components: {
    payModel
  },
  methods: {
    beforeClose() {
      this.$refs.childPay.beforeClose()
      this.openPayDiv = false
      // done();
      // clearInterval(this.paySetInterval);
    },
  }
}

</script>
<style lang="less">


@import url("assets/css/reset.css");

#app {
  font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
}
.open-pay-div {
  .el-dialog {
    background: #FDD01F;
  }
}
</style>
